export class Exporter {
    ID;
    ExporterName;
    ShortOrgName;
    MailingAddress;
    PhoneNumber;
    LicenceNumber;
    LicenceExpiryDateUTC;
    IsActive;
    OrganisationTypeID;
    ReviewRequiredPriorToDeptSubmission;
    RegisteredEstablishmentIDs;
    FeedPerDeckDefault;

    constructor({id, exporterName, mailingAddress, phoneNumber, licenceNumber, licenceExpiryDateUTC, isActive, organisationTypeID, reviewRequiredPriorToDeptSubmission, registeredEstablishmentIDs, feedPerDeckDefault, shortOrgName}) {
        this.ID = id;
        this.ExporterName = exporterName;
        this.MailingAddress = mailingAddress;
        this.PhoneNumber = phoneNumber;
        this.LicenceNumber = licenceNumber;
        this.LicenceExpiryDateUTC = licenceExpiryDateUTC;
        this.IsActive = isActive;
        this.OrganisationTypeID = organisationTypeID;
        this.ReviewRequiredPriorToDeptSubmission = reviewRequiredPriorToDeptSubmission;
        this.registeredEstablishmentIDs = registeredEstablishmentIDs;
        this.FeedPerDeckDefault = feedPerDeckDefault;
        this.ShortOrgName = shortOrgName;
    }
}